<template>
  <fragment>
    <v-main>
      <slot name="content"/>
    </v-main>
    <navigation-panel
      :btn-prev-disabled="btnPrevDisabled"
      :btn-prev-visible="btnPrevVisible"
      :btn-next-disabled="btnNextDisabled"
      :btn-next-color="btnNextColor"
      :on-btn-prev-clicked="onBtnPrevClicked"
      :on-btn-next-clicked="onBtnNextClicked"
    >
      <template v-for="(_, slotName) in $slots" #[slotName]>
        <slot :name="slotName"/>
      </template>
    </navigation-panel>
  </fragment>
</template>

<script>
import {Fragment} from "vue-frag"
import NavigationPanel from "@/components/navigation/NavigationPanel"

export default {
  name: 'widget-step-page',
  components: {
    Fragment,
    NavigationPanel,
  },
  props: {
    btnPrevDisabled: Boolean,
    btnPrevVisible: {
      type: Boolean,
      default: true
    },
    btnNextDisabled: Boolean,
    btnNextColor: {
      type: String,
      default: null
    },
    onBtnPrevClicked: Function,
    onBtnNextClicked: Function,
  },
  created() {
    document.addEventListener('keyup', this.onEnterKeyUp)
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.onEnterKeyUp)
  },
  methods: {
    /**
     * Обработка события нажатия на кнопку "Enter" на этапах виджета
     */
    onEnterKeyUp(event) {
      if (!event || !(event.key === 'Enter' || event.keyCode === 13)) {
        return
      }
      document.activeElement.blur()
      event.preventDefault()
      event.stopPropagation()
      this.onBtnNextClicked()
    }
  }
}
</script>

<style scoped>

</style>